import { styled } from '@mui/material/styles';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { TextField } from 'src/components/Fields';
import { PaymentColorPalette } from 'src/pages/payment-msi/PaymentMsiV2/styles';

type PaymentTextFieldRef = ElementRef<typeof TextField>;
type PaymentTextFieldProps = ComponentPropsWithoutRef<typeof TextField>;

export const PaymentTextField = styled(
  forwardRef<PaymentTextFieldRef, PaymentTextFieldProps>(
    ({ variant = 'filled', ...props }, ref) => {
      return <TextField variant={variant} {...props} ref={ref} />;
    },
  ),
)({
  borderRadius: '4px',

  '& .MuiFilledInput-root.Mui-disabled': {
    backgroundColor: PaymentColorPalette.inputBackgroundColor,
    color: PaymentColorPalette.inputTextDisabled,
  },

  '& .MuiFormLabel-root.Mui-disabled': {
    color: PaymentColorPalette.inputTextDisabled,
  },

  '& .MuiFormLabel-root.Mui-disabled > .MuiFormLabel-asterisk': {
    color: PaymentColorPalette.inputTextDisabled,
  },

  '& .MuiFilledInput-root': {
    backgroundColor: PaymentColorPalette.inputBackgroundColor,
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    borderBottomLeftRadius: '4px',
  },

  '& .MuiFilledInput-root:hover': {
    borderBottom: 'none',
    backgroundColor: PaymentColorPalette.inputBackgroundColor,
  },

  '& .MuiFilledInput-underline:before': {
    borderBottom: 'none !important',
  },

  '& .MuiFilledInput-underline:after': {
    borderBottom: 'none !important',
  },

  '& .MuiFilledInput-input': {
    paddingTop: '24px',
    paddingBottom: '8px',
    paddingLeft: '12px',
    paddingRight: '12px',
    color: PaymentColorPalette.inputText,
  },

  '& .MuiFilledInput-root.Mui-focused': {
    backgroundColor: PaymentColorPalette.inputBackgroundColor,
  },

  '& .MuiFilledInput-root.Mui-error': {
    border: `1px solid ${PaymentColorPalette.invalidInput}`,
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: PaymentColorPalette.labelFocused,
  },
});

// MuiInputLabel-root.Mui-focused
